module.exports = __webpack_public_path__ + "assets/img/70@3x.1bbdb0e0.png";